import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=68a090b9&scoped=true&"
import script from "./sign-up.vue?vue&type=script&lang=js&"
export * from "./sign-up.vue?vue&type=script&lang=js&"
import style0 from "./sign-up.vue?vue&type=style&index=0&id=68a090b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a090b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VForm,VRow,VSwitch,VTextField})
